import React, { createContext, useContext, useEffect, useState } from "react";
import { lerItem } from "../lib/armazenamentoSeguro";

interface MensagemData {
  id: string;
  texto: string;
  tipo: "usuario" | "assistente";
  artigos: any[];
  whatsapps: any[];
  idRespostaGptSak: number;
}

interface ConversasStorage {
  [key: string]: { [conversaId: string]: MensagemData[] };
}

interface HistoricoContextType {
  historicoApps: ConversasStorage | null;
  recarregarHistorico: () => void;
}

const HistoricoContext = createContext<HistoricoContextType | undefined>(
  undefined
);

export const HistoricoProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [historicoApps, setHistoricoApps] = useState<ConversasStorage | null>(
    null
  );

  const carregarHistorico = () => {
    const armazenado = lerItem("conversas_storage");
    if (armazenado) {
      try {
        const storage: ConversasStorage = JSON.parse(armazenado);
        setHistoricoApps(storage);
      } catch (error) {
        console.error("Erro ao parsear as conversas:", error);
        setHistoricoApps(null);
      }
    } else {
      setHistoricoApps(null);
    }
  };

  useEffect(() => {
    carregarHistorico();

    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === "conversas_storage") {
        carregarHistorico();
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <HistoricoContext.Provider
      value={{
        historicoApps,
        recarregarHistorico: carregarHistorico,
      }}
    >
      {children}
    </HistoricoContext.Provider>
  );
};

export const useHistorico = (): HistoricoContextType => {
  const context = useContext(HistoricoContext);
  if (!context) {
    throw new Error("useHistorico deve ser usado dentro do HistoricoProvider");
  }
  return context;
};
